import queryString from "query-string";
import { useEffect, useState } from "react";
import io from "socket.io-client";
import { User } from "./user";
import { Message } from "./message";
import ScrollToBottom from "react-scroll-to-bottom";

import "../ styles/room.css";

let socket;

export const Room = () => {
  const [name, setName] = useState("");
  const [room, setRoom] = useState("");
  const [sendMessage, setSendMessage] = useState("");
  const [users, setUsers] = useState([]);
  const [messages, setMessages] = useState([]);
  const ENDPOINT = "https://sahulchat.herokuapp.com/";
  useEffect(() => {
    const { name, room } = queryString.parse(window.location.search);
    setName(name);
    setRoom(room);

    socket = io(ENDPOINT);

    socket.emit("join", { name: name, room: room });

    socket.on("room data", (data) => {
      let roomMembersName = [];
      data.forEach((user) => {
        roomMembersName.push(user.name);
      });
      setUsers([...roomMembersName]);
    });

    let totalMessages = [];

    socket.on("chat message", ({ user, message }) => {
      let aMessagewithUser = { user: user, message: message };
      totalMessages.push(aMessagewithUser);
      setMessages([...totalMessages]);
    });

    socket.on("user leaves", (msg) => {});
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    socket.emit("send message", sendMessage);
    setSendMessage("");
  };
  return (
    <div className="completeRoom">
      <div className="gridSystem">
        <div className="members">
          <h4 style={{ color: "violet" }}> People </h4>
          {users.map((user, key) => {
            return (
              <div key={key}>
                {/* here iterated user */}
                <User name={user}></User>
              </div>
            );
          })}
        </div>
        <ScrollToBottom>
          <div className="chats">
            {messages.map(({ user, message }, key) => {
              return (
                <div key={key}>
                  <Message user={user} message={message} />
                </div>
              );
            })}
          </div>
        </ScrollToBottom>
      </div>
      <div className="form">
        <form onSubmit={handleSubmit}>
          <input
            className="chatbox"
            type="text"
            required
            placeholder="Enter Message"
            value={sendMessage}
            onChange={(e) => {
              setSendMessage(e.target.value);
            }}
          />
          <button className="button1">send</button>
        </form>
      </div>
    </div>
  );
};
